// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"38c3ef73","197":"9411f250","374":"e8125956","596":"41ead1be","872":"8831dc8c"}[chunkId] + ".chunk.js";
};